module.exports = __webpack_public_path__ + "static/media/293716.1fe9a910.png";